// Splits "a<sep>b" (sep = comma, semicolon, and/or whitespace) into two finite
// numbers. Returns { parts: [string, string], a: number, b: number } or null.
function splitNumberPair(raw) {
  if (typeof raw !== "string") return null;
  const parts = raw.trim().split(/[\s,;]+/).filter(Boolean);
  if (parts.length !== 2) return null;
  const a = Number(parts[0]);
  const b = Number(parts[1]);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  return { parts, a, b };
}

// Accepts "lat<sep>lng". Returns { latitude, longitude } (original string tokens)
// or null if not a valid geographic pair.
export function parseCoordinatePair(raw) {
  const result = splitNumberPair(raw);
  if (!result) return null;
  const { parts, a: lat, b: lng } = result;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { latitude: parts[0], longitude: parts[1] };
}

// Accepts "x<sep>y" for EGSA87 (projected) coordinates. No geographic range
// check — just two finite numbers. Returns { egsa87x, egsa87y } or null.
export function parseEgsa87Pair(raw) {
  const result = splitNumberPair(raw);
  if (!result) return null;
  return { egsa87x: result.parts[0], egsa87y: result.parts[1] };
}
